<template>
  <div>
    <div class="account_full_info">
      <div class="row table account_info" v-show="typeof(account_info.Account)!='undefined'">
        <div class="col">
          <div class="account_number">{{ account_info.Account }}</div>
        </div>
        <div class="col">
          <div class="account_info_money">Money:{{ account_info.Money }}</div>
        </div>
        <div class="col">

          <div>{{ account_info.MoneyFree }}
            <div class="account_info_small_top">FREE</div>
          </div>
        </div>
        <div class="col">

          <div>{{ account_info.GM }}
            <div class="account_info_small_top">GM</div>
          </div>

        </div>
        <!--    <div class="col">

              <div>{{ account_info.Fee }}
                <div class="account_info_small_top">FEE</div>
              </div>

            </div> -->
        <div class="col">
          <div>{{ getStringTime(account_info.LastChangeTime) }}</div>
        </div>
      </div>
      <CurrencyTable :positions="positions_info"></CurrencyTable>
      <PositionsTable :positions="positions_info"></PositionsTable>
      <OrdersTable :orders="orders_info"></OrdersTable>

    </div>


  </div>
</template>

<script>
//import {ref} from "vue"
import {getAccInfo, getAccOrders, getAccPositions, getAccTrades, getInstruments} from "@/store/global";
import PositionsTable from "@/components/PositionsTable";
import OrdersTable from "@/components/OrdersTable";
import CurrencyTable from "@/components/CurrencyTable";


export default {
  name: "AccountInfo",
  props: ["account"],
  components: {CurrencyTable, OrdersTable, PositionsTable},
  setup(props) {
    const account_info = getAccInfo(props.account)
    const positions_info = getAccPositions(props.account)
    const trades_info = getAccTrades(props.account)
    const orders_info = getAccOrders(props.account)
    const instruments = getInstruments()
    const getStringTime = (val) => {
      if (val) {
        let ts = new Date(val * 1000);
        return (
            pad(ts.getDate()) +
            "/" +
            pad(ts.getMonth() + 1) +
            "/" +
            ts.getFullYear() +
            " " +
            pad(ts.getHours()) +
            ":" +
            pad(ts.getMinutes())
        );
      }
      return ""
    }
    const isset = (obj, param) => {
      if (typeof (obj) != "undefined" && obj.length > 0 && typeof (obj[param]) != "undefined" && obj[param].length > 0) {
        return true
      }
      return false
    }
    const getValue = (obj, param) => {
      if (typeof (obj) != "undefined" && typeof (obj[param]) != "undefined") {
        return obj[param]
      }
      return 0
    }
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    }
    return {
      isset,
      getValue,
      account_info,
      positions_info,
      trades_info,
      orders_info,
      getStringTime,
      instruments
    }
  }
}
</script>

<style scoped>
.col {
  padding: 5px;
  text-align: center;
}

.table {
  display: table;
}

.cel, .col {
  display: table-cell;
}

.vmiddle {
  vertical-align: middle;
}

.head {

}

.account_number {

  padding: 5px 15px;
  background-color: #f7f7f7;
  border-left: 2px #e82862 solid;
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}

.account_info {
  padding-bottom: 8px;
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
  border-bottom: #d4d9dd 1px solid;
  width: calc(1030px - 36px);
}

.account_full_info {
  padding: 11px 18px;
  border: 1px #d4d9dd solid;
  border-radius: 3px;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  width: 1030px;
  margin-bottom: 10px;
}

.account_info_money {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}
</style>
